import JSZip from "jszip";
import { saveAs } from "file-saver";
import { get, ref } from "firebase/database";
import { db } from "../api/firebase";
import { exportDate } from "./dates";

export const DATA_NODES = ["projects", "firings", "segments", "kilns", "inventory"] as const;

export const buildBackupZip = async (dataMap: Record<string, unknown>): Promise<JSZip> => {
  const zip = new JSZip();
  for (const [node, data] of Object.entries(dataMap)) {
    if (data != null) {
      zip.file(`${node}.json`, JSON.stringify(data, null, 2));
    }
  }
  return zip;
};

export const exportUserData = async (uid: string): Promise<void> => {
  const snapshots = await Promise.all(
    DATA_NODES.map((node) => get(ref(db, `userdata/${uid}/${node}`)))
  );
  const dataMap: Record<string, unknown> = {};
  DATA_NODES.forEach((node, i) => {
    dataMap[node] = snapshots[i].val();
  });
  const zip = await buildBackupZip(dataMap);
  const blob = await zip.generateAsync({ type: "blob" });
  saveAs(blob, `kilnhelper-backup-${exportDate(Date.now())}.zip`);
};
